export enum CircuitType {
  NOGROUPING = 0,
  CURRENT = 1,
  LINEVOLTAGE = 2,
  PHASEVOLTAGE = 3,
}
// 时间颗粒度type
export enum AccumType {
  // 分钟
  MINUTE = 1,
  MINUTE15 = 2,
  HOUR = 3,
  DAY = 4,
}
export const AccumTypeDispaly = {
  [AccumType.MINUTE]: '每分钟',
  [AccumType.MINUTE15]: '每15分钟',
  [AccumType.HOUR]: '每小时',
  [AccumType.DAY]: '每天',
};

export enum MeasurementType {
  ACCUM = 1,
  INSTANT = 2,
}
export enum CompareType {
  DEVICE = '1',
  INDICATOR = '2',
}
export const AccumTypeOptions = Object.entries(AccumTypeDispaly).map(i => ({
  label: i[1],
  value: Number(i[0]),
}));
